import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'bau365-channel-list-item',
  templateUrl: './channel-list-item.component.html',
  styleUrls: ['./channel-list-item.component.scss'],
})
export class ChannelListItemComponent {
  @Input() text = '';
  @Input() active = false;
  @Input() news = 0;
  @Output() selectChannel = new EventEmitter<void>();

  onClick(): void {
    this.selectChannel.emit();
  }
}
